var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-timepicker',{attrs:{"input-width":"100%"},model:{value:(_vm.item.startAt),callback:function ($$v) {_vm.$set(_vm.item, "startAt", $$v)},expression:"item.startAt"}})
}
var staticRenderFns = []

export { render, staticRenderFns }